import assignmentListSlice from '../../slices/assignment/AssignmentList';
import assignmentDetailsSlice from '../../slices/assignment/AssignmentDetails';

const assignmentReducer = {
    assignmentList: assignmentListSlice,
    assignmentDetails: assignmentDetailsSlice,
};

export default assignmentReducer;
